import Vue from 'vue';

import API from './index';

const END_POINT = 'product';

export default {
  async getModifiers(id, restaurantId): Promise<any> {
    try {
      return (await API.get(`${END_POINT}/${restaurantId}/${id}`)).data || {};
    } catch (err) {
      Vue.$log.error(`${END_POINT}/getModifiers`, err);
      return {};
    }
  },
}
